module.exports = __webpack_public_path__ + "img/ethereum-logo-landscape-purple.8fb0b6eb.png";